import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import theme from "./theme";
import { ThemeProvider, CssBaseline } from "@mui/material";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Navbar from "./components/Navbar";
import Cart from "./pages/Cart/Cart";
import Profile from "./pages/Profile";
import ProductDetail from "./pages/ProductDetail";
import Footer from "./components/Footer";
import { UserContextProvider } from "./context/UserContext";

// Main application component
const App = () => {
  return (
    <>
      {/* Wrapping the application with ThemeProvider to apply the custom theme */}
      <ThemeProvider theme={theme}>
        {/* Setting up React Router for navigation */}
        <Router>
          {/* Providing user context to manage global user state */}
          <UserContextProvider>
            {/* Navbar component displayed on all pages */}
            <Navbar />
            {/* Defining application routes */}
            <Routes>
              <Route path="/product/:id" element={<ProductDetail />} />{" "}
              {/* Product detail page */}
              <Route path="/" element={<Home />} /> {/* Home page */}
              <Route path="/signup" element={<Signup />} /> {/* Signup page */}
              <Route path="/login" element={<Login />} /> {/* Login page */}
              <Route path="/cart" element={<Cart />} />{" "}
              {/* Shopping cart page */}
              <Route path="/profile" element={<Profile />} />{" "}
              {/* User profile page */}
            </Routes>
            {/* Footer component displayed on all pages */}
            <Footer />
          </UserContextProvider>
        </Router>
      </ThemeProvider>
    </>
  );
};

export default App;
